import React from 'react';
import PropTypes from 'prop-types';

import {
  FieldInput,
  FieldSelect,
  FieldRadio,
  FieldCheckbox,
  FieldDate,
  FieldButton,
  FieldTextArea,
  FieldFile,
  FieldMultiCheckbox,
  FieldMultiFileUpload,
  FieldTextNote
} from './fields';

import EditableSalesRepInfo from './editableSalesRepInfo';

import { Error } from '../design/elements';

const FormField = ({ orderData, data, error }) => {
  const { type } = data;
  let result;

  switch (type) {
    case 'Address':
    case 'AddressDetails':
    case 'Text':
    case 'Number':
      result = <FieldInput data={data} />;
      break;
    case 'Select':
      result = <FieldSelect data={data} />;
      break;
    case 'Radio':
      result = <FieldRadio data={data} />;
      break;
    case 'File':
      result = <FieldFile data={data} />;
      break;
    case 'Checkbox':
      result = <FieldCheckbox data={data} />;
      break;
    case 'Date':
      result = <FieldDate data={data} orderData={orderData} />;
      break;
    case 'Button':
      result = <FieldButton data={data} orderData={orderData} />;
      break;
    case 'TextArea':
      result = <FieldTextArea data={data} />;
      break;
    case 'MultiCheckbox':
      result = <FieldMultiCheckbox data={data} />;
      break;
    case 'MultiFileUpload':
      result = <FieldMultiFileUpload data={data} orderData={orderData} />;
      break;
    case 'TextNote':
      result = <FieldTextNote data={data} />;
      break;
    case 'EditSalesInfo':
      result = <EditableSalesRepInfo />;
      break;
    default:
      result = null;
  }

  return (
    <>
      {result}
      {error && <Error text={error} />}
    </>
  );
};

FormField.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }).isRequired,
  error: PropTypes.string
};

FormField.defaultProps = {
  error: ''
};

export default FormField;
